import React, { useRef } from 'react';
import WidgetBot from '@widgetbot/react-embed'
import styled from 'styled-components';
import BlueHero from '../../../assets/images/sprites/blueHero.jpg';
import { ThemeProps } from '../../genericComponents/globalStyles'

export function DiscordScreen() {
  const discordApi = useRef();

  function onAPI(api) {
    discordApi.current = api;
    api.on('signIn', user => {
      console.log(`Signed in as ${user.name}`, user)
    })

  }
  return (
    <div>
      <HeaderContainer>
        <Title>
          <h3>GABA Synapse</h3>
          <p>
            By having a paid subscription you will have access to voice channels</p>
        </Title>
      </HeaderContainer>
      <WidgetBot
        server="798589082212368414"
        channel="798589082212368419"
        onAPI={onAPI}
        height={600}
        width={'100%'}
        defer={false}

      />


    </div>
  )
}


const HeaderContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url('${BlueHero}');
  background-size: 100% 200px;
  background-repeat: repeat-x;
  background-color: white;
`;
const Title = styled.div`
  width: 70%;
  @media (max-width: 720px) {
    width: 100%;
    display:flex;
    flex-direction: column;
    flex: 1;
    padding: 16px 0px;
  }
  h3 {
    color: ${ThemeProps.color.gabaYellow};
    font-size: 1.5em;
  }
  p {
    font-size: 1.4em;
    color: ${ThemeProps.color.white};
  }
`;